import { StrapiLocale } from "constants/enum";

import { CmsPagePreviewStatus, CmsWrapperProps } from "./cms-website.types";
import { getCmsGraphQLClient } from "./graphql/config";
import { PagesApi } from "./graphql/api/PagesApi";

export const STRAPI_WEBSITE_API_URL = process.env.STRAPI_WEBSITE_API_URL;
export const STRAPI_API_TOKEN = process.env.STRAPI_API_TOKEN;

/**
 * New ApolloClient + PagesApi each call — no long-lived InMemoryCache across requests/pods.
 * SSG/build: fine. Hot SSR: consider one client per request.
 */
const getPagesApi = () => new PagesApi(getCmsGraphQLClient());

/**
 * Get page by slug and locale using GraphQL API
 *
 * @param params - Query parameters
 * @returns Page data wrapped in CmsWrapperProps
 */
export const getPages = async ({
    slugString,
    localeToLanguage,
    previewStatus,
}: {
    slugString: string;
    localeToLanguage: StrapiLocale;
    previewStatus: CmsPagePreviewStatus;
}): Promise<CmsWrapperProps> => {
    const page = await getPagesApi().findOne({
        slug: slugString,
        locale: localeToLanguage,
        isPreview: previewStatus === CmsPagePreviewStatus.DRAFT,
    });

    if (!page) {
        return { data: [] };
    }

    return { data: [page] };
};

/**
 * Get all pages with localizations using GraphQL API
 */
export const getPagesLocalizations = async (): Promise<CmsWrapperProps> =>
    getPagesApi().findAll();
